import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import { Form } from "formik";
import { useState } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { getFiles, updateFile } from "../../../actions/files";
import snackbarUtils from "../../../utils/snackbarUtils";
import CustomDialog from "../../commons/dialog/customDialog";
import FormikActions from "../../commons/formik/formikActions";
import FormikForm from "../../commons/formik/formikForm";
import FormikTextField from "../../commons/formik/formikTextField";
import DropZone from "../forms/dropZone/dropZone";

const validationSchema = yup.object({
  descripcion: yup.string().required("Campo obligatorio"),
});

const initialValues = {
  descripcion: "",
};
const EditFileDialog = ({ open, file, handleClose }) => {
  const dispatch = useDispatch();
  const [dropzoneFile, setDropzoneFile] = useState([]);
  const [attachmentError, setAttachmentError] = useState(false);

  const handleSubmit = (values) => {
    const model = {
      ...values,
      base64: dropzoneFile.length > 0 ? dropzoneFile[0].value : file.base64,
    };
    dispatch(updateFile(model)).then((res) => {
      dispatch(getFiles()).then(() => {
        snackbarUtils.success("Archivo modificado exitosamente");
        handleClose();
      });
    });
  };

  return (
    <CustomDialog open={open} onClose={handleClose}>
      <DialogTitle>Editar Archivo</DialogTitle>
      <DialogContent>
        <FormikForm
          initialValues={file ? file : initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}>
          <Form>

            <FormikTextField
              name="descripcion"
              label="Descripción"
              type="text"
              fullWidth
              sx={{
                marginTop: 5,
              }}
            />
            <Box
              sx={{
                marginTop: 5,
              }}>
              <DropZone
                files={dropzoneFile}
                setFiles={setDropzoneFile}
                configuration={{
                  maxFileSizeBytes: 500000,
                  fileMinSizeInBytes: 300,
                  oneFile: true,
                  typifyAttachmentFile: false,
                }}
                error={attachmentError}
                setError={setAttachmentError}
                accept={{ "application/csv": [".csv"] }}
              />
            </Box>
            <DialogActions>
              <FormikActions submitText="Guardar" handleCancel={handleClose} />
            </DialogActions>
          </Form>
        </FormikForm>
      </DialogContent>
    </CustomDialog>
  );
};

export default EditFileDialog;
